import { Helmet } from "react-helmet";
import Clients from "../components/Clients2";
import "../styles/About.css";
import WWC1 from "../assets/img/wcc-1.png";

const About = () => {
  return (
    <div className="about-main">
      <Helmet>
        <title>Colorkaar | About</title>
        <meta
          name="description"
          content="Colorkaar - Color Grading Boutique Commercials , Films and Webseries Color Grading Services"
        />
      </Helmet>

      <div className="about-main-desktop">
        <div className="about-banner">
          <div className="about-about-body">
            <h3>High-end Color. Fast Turnarounds. Zero Fuss.
            </h3>
            <p className="about-about-description">
              Colorkaar is a color grading boutique based in Mumbai, crafting bold, polished visuals for filmmakers, brands, and creatives around the world.
            </p>
          </div>
          <img
            src="https://colorkaar.com/aboutbanner.webp"
            alt="colorkaar-profile-studio-setup"
            className="about-banner-img"
            loading=""
          />
          <div className="about-para">
            <h3>A Studio That Keeps It Personal
            </h3>
            <p className="about-description">
              Colorkaar was founded by Uday Oswal — a colorist with a cinematographer’s eye and a decade-long obsession with how visuals breathe, shift, and hold emotion.
              What began as a love for image processing soon evolved into a career rooted in color, craft, and creative precision. With over 9 years in post-production, Uday has shaped the final look of hundreds of projects — from commercials and films to music videos and branded content.
              <br /><br />Before starting Colorkaar, he trained as a cinematographer — a background that gives him a rare advantage in the grade. He doesn’t just read scopes or tweak curves — he understands how the image was lit, framed, and felt on set. That intuition helps him translate a director’s intent into visual tone with clarity and care.
            </p>
          </div>




        </div>


        <h3 className="about-main-desktop-contact">Why Work With Colorkaar?</h3>

        <section className="section">
          <div className="card">
            <h3>Expert-Led Craft
            </h3>
            <p>
              Over 9 years of hands-on experience — with a cinematographer’s instinct behind every grade. It’s not just about how it looks, but how it feels.

            </p>
          </div>
          <div className="card">
            <h3>Fast, Aligned, Reliable
            </h3>
            <p>
              We move quickly without cutting corners — keeping deadlines tight and feedback loops clear, so your project stays on track.
            </p>
          </div>
          <div className="card">
            <h3>Remote-First & Collaborative
            </h3>
            <p>Designed to work seamlessly across time zones. Our remote workflow is smooth, secure, and built for real creative collaboration — wherever you are.

            </p>
          </div>
        </section>
        <h3 className="about-main-desktop-client">Philosophy</h3>

        <section className="features-section">
          <div className="feature-row">
            <div className="feature-text">
              <h3>Intentional Color</h3>
              <p>No templates. No trendy overgrades. Just clean , emotive color that fits the feel.
              </p>
            </div>
            <div className="feature-video square">
              <iframe src="https://www.youtube.com/embed/dQw4w9WgXcQ" title="Intentional Color"
                frameborder="0" allowfullscreen></iframe>
            </div>
          </div>

          <div className="feature-row">
            <div className="feature-video square">
              <iframe src="https://www.youtube.com/embed/dQw4w9WgXcQ" title="Every Frame in Context"
                frameborder="0" allowfullscreen></iframe>
            </div>
            <div className="feature-text">
              <h3>Every Frame in Context
              </h3>
              <p>We grade the sequence — not just the single frame. Mood and rhythm come first.
              </p>
            </div>
          </div>

          <div className="feature-row">
            <div className="feature-text">
              <h3>Story-Led Choices
              </h3>
              <p>From subtle shifts to bold tones — every move is made with the narrative in mind.</p>
            </div>
            <div className="feature-video square">
              <iframe src="https://www.youtube.com/embed/dQw4w9WgXcQ" title="Story-Led Choices"
                frameborder="0" allowfullscreen></iframe>
            </div>
          </div>
        </section>
        <h3 className="about-main-desktop-client">Our Team</h3>
        <section className="team-section">
          <div className="team-grid">
            {[
              {
                imgAlt: "colorkaar-focus",
                imgURL: WWC1,
                name: "Expert-Led Craft",
                designation:
                  "Founder",
              }, {
                imgAlt: "colorkaar-focus",
                imgURL: WWC1,
                name: "Expert-Led Craft",
                designation:
                  "Founder",
              }, {
                imgAlt: "colorkaar-focus",
                imgURL: WWC1,
                name: "Expert-Led Craft",
                designation:
                  "Founder",
              }, {
                imgAlt: "colorkaar-focus",
                imgURL: WWC1,
                name: "Expert-Led Craft",
                designation:
                  "Founder",
              }, {
                imgAlt: "colorkaar-focus",
                imgURL: WWC1,
                name: "Expert-Led Craft",
                designation:
                  "Founder",
              },

            ].map((m, i) => (
              <div className="team-member">
                <img src={m.imgURL} alt={m.imgAlt} />
                <h3>{m.name}</h3>
                <p>{m.designation}</p>
              </div>
            ))}
          </div>
        </section>

        <h3 className="about-main-desktop-client">SOME OF OUR CLIENTS</h3>

        <Clients />

      </div>
    </div>
  );
};

export default About;
